import React, { useEffect, useRef, useState } from "react";
import styles from "./comp_css/chapter_6.module.css";
import Head from "next/head";
import { Link } from "@mui/material";
import { useRouter } from "next/router";
import MembershipModal from "../../../components/Modal/MembershipModal";
import BlockData from "../../../central-doctraine-json/chapter6.json";
import Common_html from "./Common_html";

export default function Chapter_6() {
  // const corosalref = useRef()

  // useEffect(() => {
  //   if (corosalref.current) {
  //     corosalref.current.scrollIntoView({
  //       behavior: "smooth",
  //       block: "nearest",
  //       inline: "start"
  //     })
  //   }
  //   console.log("CurrentImageComponent", corosalref.current);
  // }, [corosalref.current])

  const router = useRouter();
  const location = useRouter();
  const { pathname } = location;


  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };

  return (
    <>
      <Head>
        <title>THE FRAMEWORK OF PRACTICE | School of Our Divine Infinite Being</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
        <meta
          name="keywords"
          content="Divine Infinite Being, Central Doctrine, Chapter-VI"
        ></meta>
        <meta
          property="og:title"
          content="THE FRAMEWORK OF PRACTICE | School of Our Divine Infinite Being"
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:image"
          content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter6_OG_image_Mithun_04-10-2023_v1_new.webp"
        ></meta>
        <meta property="og:image:alt" content="Illustration of a structured pathway with illuminated steps leading toward a divine light, symbolizing the Framework of Practice within the Divine Infinite Being's doctrine. The pathway is bordered by symbolic markers representing key practices and disciplines guiding spiritual progress."></meta>
        <meta
          property="og:description"
          content="The framework for advancement in the School of Our Divine Infinite Being is a ceremonial Theurgic practice that draws from the science of spiritual advancement agnostically."
        ></meta>
        <meta property="og:image:width" content="1200"></meta>
        <meta property="og:image:height" content="627"></meta>
        <meta
          property="og:url"
          content="https://www.divineinfinitebeing.com/central-doctrine?chapter=5"
        ></meta>

        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta property="twitter:image" content="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/meta_data/Chapter6_OG_image_Mithun_04-10-2023_v1_new.webp"></meta>
        <meta property="twitter:image:alt" content="Illustration of a structured pathway with illuminated steps leading toward a divine light, symbolizing the Framework of Practice within the Divine Infinite Being's doctrine. The pathway is bordered by symbolic markers representing key practices and disciplines guiding spiritual progress."></meta>
        <meta name="twitter:url" content="https://www.divineinfinitebeing.com/central-doctrine?chapter=5"></meta>
        <meta name="twitter:title" content="THE FRAMEWORK OF PRACTICE | School of Our Divine Infinite Being"></meta>
        <meta name="twitter:description" content="The framework for advancement in the School of Our Divine Infinite Being is a ceremonial Theurgic practice that draws from the science of spiritual advancement agnostically."></meta>
         <link rel="canonical" href="https://www.divineinfinitebeing.com/central-doctrine?chapter=6" />
      </Head>


            <Common_html BlockData={BlockData} />

      <MembershipModal membershipOpen={membershipOpen} setMembershipOpen={setMembershipOpen}/>
    </>
  );
}
